"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * pyramid-gateway-service
 * service that externalize entities and cycles to pyramid
 *
 * The version of the OpenAPI document: 2.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.TaskCountsGroupBy = exports.ScheduledEventType = exports.ScheduledEventRequestStatus = exports.LocationType = exports.LDMultiKindContextKindEnum = exports.IRecurrenceFrequencyEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.IRecurrenceFrequencyEnum = {
    Monthly: 'monthly',
    Weekly: 'weekly',
    Daily: 'daily'
};
exports.LDMultiKindContextKindEnum = {
    Multi: 'multi'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LocationType = {
    Building: 'Building',
    Floor: 'Floor',
    Operational: 'Operational',
    Area: 'Area',
    NoFlight: 'No Flight'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ScheduledEventRequestStatus = {
    Pending: 'pending',
    Approved: 'approved',
    Denied: 'denied',
    NoActionRequired: 'noActionRequired'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ScheduledEventType = {
    Undefined: 'undefined',
    Activity: 'activity',
    Shift: 'shift',
    Break: 'break',
    BusinessDay: 'business_day',
    TimeOnHook: 'time_on_hook'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TaskCountsGroupBy = {
    ProcessTypeId: 'processTypeId',
    ProductId: 'productId'
};
/**
 * DefaultApi - axios parameter creator
 * @export
 */
var DefaultApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCranes: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/cranes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication sessionid required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarQueryParameter, "sessionid", configuration)];
                        case 1:
                            // authentication sessionid required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} from unix timestamp
         * @param {number} to unix timestamp
         * @param {string} [device] device_sn (device serial number). must use one of the two: device or craneId
         * @param {number} [craneId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents: function (from, to, device, craneId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'from' is not null or undefined
                            (0, common_1.assertParamExists)('getEvents', 'from', from);
                            // verify required parameter 'to' is not null or undefined
                            (0, common_1.assertParamExists)('getEvents', 'to', to);
                            localVarPath = "/api/v1/events";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication sessionid required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarQueryParameter, "sessionid", configuration)];
                        case 1:
                            // authentication sessionid required
                            _a.sent();
                            if (from !== undefined) {
                                localVarQueryParameter['from'] = from;
                            }
                            if (to !== undefined) {
                                localVarQueryParameter['to'] = to;
                            }
                            if (device !== undefined) {
                                localVarQueryParameter['device'] = device;
                            }
                            if (craneId !== undefined) {
                                localVarQueryParameter['craneId'] = craneId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get load types and process type, with their frequency of use in the last daysBack days
         * @param {number} siteId
         * @param {number} [daysBack]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadAndProcessTypes: function (siteId, daysBack, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'siteId' is not null or undefined
                            (0, common_1.assertParamExists)('getLoadAndProcessTypes', 'siteId', siteId);
                            localVarPath = "/api/v1/load-types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication sessionid required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarQueryParameter, "sessionid", configuration)];
                        case 1:
                            // authentication sessionid required
                            _a.sent();
                            if (siteId !== undefined) {
                                localVarQueryParameter['siteId'] = siteId;
                            }
                            if (daysBack !== undefined) {
                                localVarQueryParameter['daysBack'] = daysBack;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get locations for a site, including lastTaggedFloor locations are ordered by their area
         * @param {number} siteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations: function (siteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'siteId' is not null or undefined
                            (0, common_1.assertParamExists)('getLocations', 'siteId', siteId);
                            localVarPath = "/api/v1/sites/{siteId}/locations"
                                .replace("{".concat("siteId", "}"), encodeURIComponent(String(siteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication sessionid required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarQueryParameter, "sessionid", configuration)];
                        case 1:
                            // authentication sessionid required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all products for a site
         * @param {number} siteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: function (siteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'siteId' is not null or undefined
                            (0, common_1.assertParamExists)('getProducts', 'siteId', siteId);
                            localVarPath = "/api/v1/sites/{siteId}/products"
                                .replace("{".concat("siteId", "}"), encodeURIComponent(String(siteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication sessionid required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarQueryParameter, "sessionid", configuration)];
                        case 1:
                            // authentication sessionid required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} siteId
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPyramidUserMultiContext: function (siteId, id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'siteId' is not null or undefined
                            (0, common_1.assertParamExists)('getPyramidUserMultiContext', 'siteId', siteId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getPyramidUserMultiContext', 'id', id);
                            localVarPath = "/api/v1/sites/{siteId}/context/pyramid-user/{id}"
                                .replace("{".concat("siteId", "}"), encodeURIComponent(String(siteId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication sessionid required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarQueryParameter, "sessionid", configuration)];
                        case 1:
                            // authentication sessionid required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get site day schedule
         * @param {number} siteId
         * @param {string} date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleForDay: function (siteId, date, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'siteId' is not null or undefined
                            (0, common_1.assertParamExists)('getScheduleForDay', 'siteId', siteId);
                            // verify required parameter 'date' is not null or undefined
                            (0, common_1.assertParamExists)('getScheduleForDay', 'date', date);
                            localVarPath = "/api/v1/sites/{siteId}/schedule/{date}"
                                .replace("{".concat("siteId", "}"), encodeURIComponent(String(siteId)))
                                .replace("{".concat("date", "}"), encodeURIComponent(String(date)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication sessionid required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarQueryParameter, "sessionid", configuration)];
                        case 1:
                            // authentication sessionid required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get site crane tags
         * @param {number} siteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteCraneTags: function (siteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'siteId' is not null or undefined
                            (0, common_1.assertParamExists)('getSiteCraneTags', 'siteId', siteId);
                            localVarPath = "/api/v1/sites/{siteId}/crane-tags"
                                .replace("{".concat("siteId", "}"), encodeURIComponent(String(siteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication sessionid required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarQueryParameter, "sessionid", configuration)];
                        case 1:
                            // authentication sessionid required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get task counts
         * @param {string} [minTasksTime]
         * @param {boolean} [includeCycles]
         * @param {Array<number>} [processTypeIds]
         * @param {Array<number>} [loadTypeIds]
         * @param {string} [maxTasksTime]
         * @param {Array<number>} [processIds]
         * @param {Array<number>} [floorIds]
         * @param {Array<number>} [areaIds]
         * @param {number} [time]
         * @param {boolean} [loadTypeBreakdown]
         * @param {TaskCountsGroupBy} [groupBy]
         * @param {number} [siteId]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getSiteTaskCount: function (minTasksTime, includeCycles, processTypeIds, loadTypeIds, maxTasksTime, processIds, floorIds, areaIds, time, loadTypeBreakdown, groupBy, siteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/task-counts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication sessionid required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarQueryParameter, "sessionid", configuration)];
                        case 1:
                            // authentication sessionid required
                            _a.sent();
                            if (minTasksTime !== undefined) {
                                localVarQueryParameter['minTasksTime'] = minTasksTime;
                            }
                            if (includeCycles !== undefined) {
                                localVarQueryParameter['includeCycles'] = includeCycles;
                            }
                            if (processTypeIds) {
                                localVarQueryParameter['processTypeIds'] = processTypeIds;
                            }
                            if (loadTypeIds) {
                                localVarQueryParameter['loadTypeIds'] = loadTypeIds;
                            }
                            if (maxTasksTime !== undefined) {
                                localVarQueryParameter['maxTasksTime'] = maxTasksTime;
                            }
                            if (processIds) {
                                localVarQueryParameter['processIds'] = processIds;
                            }
                            if (floorIds) {
                                localVarQueryParameter['floorIds'] = floorIds;
                            }
                            if (areaIds) {
                                localVarQueryParameter['areaIds'] = areaIds;
                            }
                            if (time !== undefined) {
                                localVarQueryParameter['time'] = time;
                            }
                            if (loadTypeBreakdown !== undefined) {
                                localVarQueryParameter['loadTypeBreakdown'] = loadTypeBreakdown;
                            }
                            if (groupBy !== undefined) {
                                localVarQueryParameter['groupBy'] = groupBy;
                            }
                            if (siteId !== undefined) {
                                localVarQueryParameter['siteId'] = siteId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get task counts by floors
         * @param {number} siteId
         * @param {number} processId
         * @param {number} time
         * @param {Array<number>} [floorIds]
         * @param {number} [areaId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteTaskCountByFloors: function (siteId, processId, time, floorIds, areaId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'siteId' is not null or undefined
                            (0, common_1.assertParamExists)('getSiteTaskCountByFloors', 'siteId', siteId);
                            // verify required parameter 'processId' is not null or undefined
                            (0, common_1.assertParamExists)('getSiteTaskCountByFloors', 'processId', processId);
                            // verify required parameter 'time' is not null or undefined
                            (0, common_1.assertParamExists)('getSiteTaskCountByFloors', 'time', time);
                            localVarPath = "/api/v1/task-counts/{siteId}/by-floors"
                                .replace("{".concat("siteId", "}"), encodeURIComponent(String(siteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication sessionid required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarQueryParameter, "sessionid", configuration)];
                        case 1:
                            // authentication sessionid required
                            _a.sent();
                            if (processId !== undefined) {
                                localVarQueryParameter['processId'] = processId;
                            }
                            if (floorIds) {
                                localVarQueryParameter['floorIds'] = floorIds;
                            }
                            if (areaId !== undefined) {
                                localVarQueryParameter['areaId'] = areaId;
                            }
                            if (time !== undefined) {
                                localVarQueryParameter['time'] = time;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} siteId
         * @param {number} [from]
         * @param {number} [to]
         * @param {number} [craneId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStepCycles: function (siteId, from, to, craneId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'siteId' is not null or undefined
                            (0, common_1.assertParamExists)('getStepCycles', 'siteId', siteId);
                            localVarPath = "/api/v1/sites/{siteId}/step-cycles"
                                .replace("{".concat("siteId", "}"), encodeURIComponent(String(siteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication sessionid required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarQueryParameter, "sessionid", configuration)];
                        case 1:
                            // authentication sessionid required
                            _a.sent();
                            if (from !== undefined) {
                                localVarQueryParameter['from'] = from;
                            }
                            if (to !== undefined) {
                                localVarQueryParameter['to'] = to;
                            }
                            if (craneId !== undefined) {
                                localVarQueryParameter['craneId'] = craneId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
var DefaultApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCranes: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCranes(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.getCranes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} from unix timestamp
         * @param {number} to unix timestamp
         * @param {string} [device] device_sn (device serial number). must use one of the two: device or craneId
         * @param {number} [craneId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents: function (from, to, device, craneId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getEvents(from, to, device, craneId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.getEvents']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get load types and process type, with their frequency of use in the last daysBack days
         * @param {number} siteId
         * @param {number} [daysBack]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadAndProcessTypes: function (siteId, daysBack, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLoadAndProcessTypes(siteId, daysBack, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.getLoadAndProcessTypes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get locations for a site, including lastTaggedFloor locations are ordered by their area
         * @param {number} siteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations: function (siteId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLocations(siteId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.getLocations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get all products for a site
         * @param {number} siteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: function (siteId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProducts(siteId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.getProducts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} siteId
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPyramidUserMultiContext: function (siteId, id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPyramidUserMultiContext(siteId, id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.getPyramidUserMultiContext']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get site day schedule
         * @param {number} siteId
         * @param {string} date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleForDay: function (siteId, date, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getScheduleForDay(siteId, date, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.getScheduleForDay']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get site crane tags
         * @param {number} siteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteCraneTags: function (siteId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSiteCraneTags(siteId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.getSiteCraneTags']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get task counts
         * @param {string} [minTasksTime]
         * @param {boolean} [includeCycles]
         * @param {Array<number>} [processTypeIds]
         * @param {Array<number>} [loadTypeIds]
         * @param {string} [maxTasksTime]
         * @param {Array<number>} [processIds]
         * @param {Array<number>} [floorIds]
         * @param {Array<number>} [areaIds]
         * @param {number} [time]
         * @param {boolean} [loadTypeBreakdown]
         * @param {TaskCountsGroupBy} [groupBy]
         * @param {number} [siteId]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getSiteTaskCount: function (minTasksTime, includeCycles, processTypeIds, loadTypeIds, maxTasksTime, processIds, floorIds, areaIds, time, loadTypeBreakdown, groupBy, siteId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSiteTaskCount(minTasksTime, includeCycles, processTypeIds, loadTypeIds, maxTasksTime, processIds, floorIds, areaIds, time, loadTypeBreakdown, groupBy, siteId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.getSiteTaskCount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get task counts by floors
         * @param {number} siteId
         * @param {number} processId
         * @param {number} time
         * @param {Array<number>} [floorIds]
         * @param {number} [areaId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteTaskCountByFloors: function (siteId, processId, time, floorIds, areaId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSiteTaskCountByFloors(siteId, processId, time, floorIds, areaId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.getSiteTaskCountByFloors']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} siteId
         * @param {number} [from]
         * @param {number} [to]
         * @param {number} [craneId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStepCycles: function (siteId, from, to, craneId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStepCycles(siteId, from, to, craneId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.getStepCycles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
var DefaultApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCranes: function (options) {
            return localVarFp.getCranes(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DefaultApiGetEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents: function (requestParameters, options) {
            return localVarFp.getEvents(requestParameters.from, requestParameters.to, requestParameters.device, requestParameters.craneId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get load types and process type, with their frequency of use in the last daysBack days
         * @param {DefaultApiGetLoadAndProcessTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadAndProcessTypes: function (requestParameters, options) {
            return localVarFp.getLoadAndProcessTypes(requestParameters.siteId, requestParameters.daysBack, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get locations for a site, including lastTaggedFloor locations are ordered by their area
         * @param {DefaultApiGetLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations: function (requestParameters, options) {
            return localVarFp.getLocations(requestParameters.siteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all products for a site
         * @param {DefaultApiGetProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: function (requestParameters, options) {
            return localVarFp.getProducts(requestParameters.siteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DefaultApiGetPyramidUserMultiContextRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPyramidUserMultiContext: function (requestParameters, options) {
            return localVarFp.getPyramidUserMultiContext(requestParameters.siteId, requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get site day schedule
         * @param {DefaultApiGetScheduleForDayRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleForDay: function (requestParameters, options) {
            return localVarFp.getScheduleForDay(requestParameters.siteId, requestParameters.date, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get site crane tags
         * @param {DefaultApiGetSiteCraneTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteCraneTags: function (requestParameters, options) {
            return localVarFp.getSiteCraneTags(requestParameters.siteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get task counts
         * @param {DefaultApiGetSiteTaskCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getSiteTaskCount: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getSiteTaskCount(requestParameters.minTasksTime, requestParameters.includeCycles, requestParameters.processTypeIds, requestParameters.loadTypeIds, requestParameters.maxTasksTime, requestParameters.processIds, requestParameters.floorIds, requestParameters.areaIds, requestParameters.time, requestParameters.loadTypeBreakdown, requestParameters.groupBy, requestParameters.siteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get task counts by floors
         * @param {DefaultApiGetSiteTaskCountByFloorsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteTaskCountByFloors: function (requestParameters, options) {
            return localVarFp.getSiteTaskCountByFloors(requestParameters.siteId, requestParameters.processId, requestParameters.time, requestParameters.floorIds, requestParameters.areaId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DefaultApiGetStepCyclesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStepCycles: function (requestParameters, options) {
            return localVarFp.getStepCycles(requestParameters.siteId, requestParameters.from, requestParameters.to, requestParameters.craneId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
var DefaultApi = /** @class */ (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCranes = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCranes(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DefaultApiGetEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getEvents = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getEvents(requestParameters.from, requestParameters.to, requestParameters.device, requestParameters.craneId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get load types and process type, with their frequency of use in the last daysBack days
     * @param {DefaultApiGetLoadAndProcessTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getLoadAndProcessTypes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getLoadAndProcessTypes(requestParameters.siteId, requestParameters.daysBack, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get locations for a site, including lastTaggedFloor locations are ordered by their area
     * @param {DefaultApiGetLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getLocations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getLocations(requestParameters.siteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all products for a site
     * @param {DefaultApiGetProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getProducts = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getProducts(requestParameters.siteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DefaultApiGetPyramidUserMultiContextRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getPyramidUserMultiContext = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getPyramidUserMultiContext(requestParameters.siteId, requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get site day schedule
     * @param {DefaultApiGetScheduleForDayRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getScheduleForDay = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getScheduleForDay(requestParameters.siteId, requestParameters.date, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get site crane tags
     * @param {DefaultApiGetSiteCraneTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getSiteCraneTags = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getSiteCraneTags(requestParameters.siteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get task counts
     * @param {DefaultApiGetSiteTaskCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getSiteTaskCount = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getSiteTaskCount(requestParameters.minTasksTime, requestParameters.includeCycles, requestParameters.processTypeIds, requestParameters.loadTypeIds, requestParameters.maxTasksTime, requestParameters.processIds, requestParameters.floorIds, requestParameters.areaIds, requestParameters.time, requestParameters.loadTypeBreakdown, requestParameters.groupBy, requestParameters.siteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get task counts by floors
     * @param {DefaultApiGetSiteTaskCountByFloorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getSiteTaskCountByFloors = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getSiteTaskCountByFloors(requestParameters.siteId, requestParameters.processId, requestParameters.time, requestParameters.floorIds, requestParameters.areaId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DefaultApiGetStepCyclesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getStepCycles = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getStepCycles(requestParameters.siteId, requestParameters.from, requestParameters.to, requestParameters.craneId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DefaultApi;
}(base_1.BaseAPI));
exports.DefaultApi = DefaultApi;
